const state = {
  dialogReconnectingInformation: false,
  dialogTransferCallReceived: false,
  dialogPauseAlert: false,
  dialogAgentAbsentDialog: false,
};

export default state;
